import styled from 'styled-components';
import { defaultColors } from '../../../styles/style-guide';

export const SelectBox = styled.div<{ $colorText?: string; $borderColor?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
  border: 1px solid ${({ $borderColor }) => $borderColor || defaultColors.primary};
  color: ${({ $colorText }) => $colorText || defaultColors.primary};
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0 1rem;
  border-radius: 0.25rem;
  height: 40px;
  cursor: pointer;
  background-color: #fffbfb;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ListSelectBox = styled.li<{ $colorText?: string}>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  padding: 0 1rem;
  width: 100%;
  height: 40px;
  background-color: #fffbfb; 
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${({ $colorText }) => $colorText || defaultColors.primary};
`;

export const CustomInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;

export const LabelContainer = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 0.75rem;
  gap: 0.75rem;
  color: ${({ $color }) => $color};
  font-size: 0.875rem;
  font-weight: 400;
`;

export const Input = styled.input<{ $hasError: boolean; $borderColor: string; $focusColor: string; $errorColor: string }>`
  height: 2.5rem;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid ${({ $hasError, $borderColor, $errorColor }) => ($hasError ? $errorColor : $borderColor)};
  padding: 0 1rem;
  font-size: 0.875rem;
  outline: none;
  background-color: ${defaultColors.white};
  color: ${defaultColors.secondary};
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${({ $focusColor }) => $focusColor};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
`;

export const ErrorMessage = styled.span`
  font-size: 0.75rem;
  color: #ef4444;
`;